module.exports = __webpack_public_path__ + "assets/images/officeBuilding-02.58dcfc59c0d439030adef4fcb10cf9e9.svg";